<p-table
	#dt
	*ngIf="tableDataModel"
	styleClass="p-datatable-responsive-demo"
	[value]="dataObject"
	[columns]="tableDataModel.columns"
	[loading]="!tableDataModel"
	[globalFilterFields]="app.keys(tableDataModel)"
	[rowHover]="true"
	[rows]="25"
	[showCurrentPageReport]="true"
	[rowsPerPageOptions]="[10, 25, 50, 100]"
	responsiveLayout="scroll"
	[paginator]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} recordName"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex w-100">
			<div class="flex-fill">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
			<fa-icon
				[icon]="['far', 'columns']"
				size="2x"
				class="ms-4 my-auto"
				(click)="app.tableColumnOverlayPanelContent = tableDataModel; app.tableColumnOverlayPanelDisplay.next($event)"
			></fa-icon>
		</div>
	</ng-template>
	<ng-template pTemplate="header" let-columns>
		<tr>
			<ng-container *ngFor="let col of columns">
				<th
					*ngIf="col.display"
					[pSortableColumn]="
						col.dataObjectDisplayIndex ? col.dataProperty[col.dataObjectDisplayIndex]?.col.dataObjectDisplayProperty : col.dataProperty
					"
				>
					<div class="d-flex w-100">
						{{ col.displayName }}
						<p-sortIcon [field]="col.dataProperty"></p-sortIcon>
						<div class="ms-auto">
							<ng-container *ngIf="col.filterType !== 'select'">
								<p-columnFilter
									[type]="col.filterType"
									[field]="col.filterProperty || col.dataProperty"
									display="menu"
									class="ms-auto"
								></p-columnFilter>
							</ng-container>
							<ng-container *ngIf="col.filterType === 'select'">
								<p-columnFilter
									[field]="col.filterProperty || col.dataProperty"
									[matchMode]="col.filterSelectMatchType"
									display="menu"
									[showMatchModes]="false"
									[showOperator]="false"
									[showAddButton]="false"
									class="ml-auto"
								>
									<ng-template pTemplate="header">
										<div class="px-3 pt-3 pb-0">
											<span class="font-bold">{{ col.displayName }}</span>
										</div>
									</ng-template>
									<ng-template pTemplate="filter" let-value let-filter="filterCallback">
										<p-multiSelect
											[ngModel]="value"
											[options]="col.filterSelectArray"
											optionValue="value"
											optionDisabled="disabled"
											placeholder="Any"
											(onChange)="filter($event.value)"
										>
											<ng-template let-option pTemplate="item">
												<div class="p-multiselect-representative-option">
													<fa-icon *ngIf="option.meta" [icon]="[option.faIconClass || 'far', option.meta]" class="me-2"></fa-icon>
													<span class="ml-1">{{ option.label }}</span>
												</div>
											</ng-template>
										</p-multiSelect>
									</ng-template>
								</p-columnFilter>
							</ng-container>
						</div>
					</div>
				</th>
			</ng-container>
		</tr>
	</ng-template>
	<ng-template let-rec let-columns="columns" pTemplate="body">
		<tr (click)="dataTableRowOnClickChange.emit(rec)">
			<ng-container *ngFor="let col of columns">
				<td *ngIf="col.display">
					<ng-container *ngIf="!col.imageView">
						{{ rec[col.dataProperty] | arrayObject: col.dataObjectDisplayIndex:col.dataObjectDisplayProperty | phoneFormat }}
					</ng-container>
					<ng-container *ngIf="col.imageView">
						<fa-icon [icon]="col.imagePrefix || rec[col.dataProperty]"></fa-icon>
					</ng-container>
				</td>
			</ng-container>
		</tr>
	</ng-template>
</p-table>
